import * as React from 'react'
import { PlannedMaintenance as DesignSystemPlannedMaintenance } from '@tumelo/designsystem'
import logoImage from '@tumelo/designsystem/src/_assets/Main_Logo_Tumelo_White-min.png'

export const PlannedMaintenance: React.FC = () => {
  const heading =
    'Planned maintenance: we are currently performing scheduled maintenance. We will be back as soon as possible.'
  return <DesignSystemPlannedMaintenance logoSrc={logoImage.src} heading={heading} />
}
